import { Link } from "react-router-dom";
import { ShoppingBag, User, LogOut } from "lucide-react";
import { Logo } from "./Logo";
import { useCart } from "../../contexts/CartContext";
import { useAuth } from "../../contexts/AuthContext";

export const ShopHeader = () => {
  const { count, setOpen } = useCart();
  const { user, logout } = useAuth();
  return (
    <header className="sticky top-0 z-50 bg-[#F6F5F0]/90 backdrop-blur-xl border-b border-[#D1CFC8]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="header-logo"><Logo /></Link>
        <nav className="flex items-center gap-5 md:gap-7 text-sm font-medium text-[#4A4D48]">
          <Link to="/" className="hover:text-[#1F5A34]">Home</Link>
          <Link to="/shop" data-testid="nav-shop" className="hover:text-[#1F5A34]">Shop</Link>
          {user ? (
            <>
              <Link to="/account" data-testid="nav-account" className="hover:text-[#1F5A34] flex items-center gap-1"><User className="w-4 h-4" /> {user.name?.split(" ")[0] || "Account"}</Link>
              {user.role === "admin" && <Link to="/admin" data-testid="nav-admin" className="hover:text-[#1F5A34]">Admin</Link>}
              <button onClick={logout} data-testid="logout-btn" className="hover:text-[#1F5A34]"><LogOut className="w-4 h-4" /></button>
            </>
          ) : (
            <Link to="/login" data-testid="nav-login" className="hover:text-[#1F5A34]">Login</Link>
          )}
          <button onClick={() => setOpen(true)} data-testid="cart-button" className="relative">
            <ShoppingBag className="w-5 h-5 text-[#1F5A34]" />
            {count > 0 && <span data-testid="cart-count" className="absolute -top-2 -right-2 w-4 h-4 rounded-full bg-[#69A544] text-white text-[10px] flex items-center justify-center">{count}</span>}
          </button>
        </nav>
      </div>
    </header>
  );
};
